export default __webpack_public_path__ + "static/media/Talha_Shabbir.f191cd58.png";